var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.publisher,
        title: _vm.$t("DELETE_AFFILIATE_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("DELETE_AFFILIATE_MODAL_CANCEL_ACTION"),
        "confirm-action-text": _vm.$t("DELETE_AFFILIATE_MODAL_CONFIRM_ACTION"),
        "confirm-button-loading": _vm.loadingDeletingPublisher,
        "show-cancel-button": _vm.showActions,
        "show-confirm-button": _vm.showActions
      },
      on: { confirm: _vm.confirmDelete, close: _vm.closeDeleteModal }
    },
    [
      !_vm.publisherReferences && _vm.loadingPublisherReferences
        ? _c(
            "div",
            [
              _c("Loader", { attrs: { "custom-class": "size-sm" } }),
              _vm._v(" "),
              _c("i18n", {
                attrs: { path: _vm.checkReferencesText, tag: "span" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "items",
                      fn: function() {
                        return [
                          _c("strong", { staticClass: "f-s-13" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "DELETE_AFFILIATE_MODAL_CHECK_ASSOCIATION_ITEMS"
                                )
                              )
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3571374075
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.publisherReferences && !_vm.publisherReferences.hasReferences
        ? _c("i18n", {
            attrs: {
              path: "DELETE_AFFILIATE_MODAL_NONE_ASSOCIATION_TEXT",
              tag: "p"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "publisherName",
                  fn: function() {
                    return [_c("strong", [_vm._v(_vm._s(_vm.publisher.name))])]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2101422650
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.publisherReferences && _vm.publisherReferences.hasReferences
        ? _c("div", [
            _c(
              "p",
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("DELETE_AFFILIATE_MODAL_CONFIRM_QUESTION")) +
                    "\n      "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("i18n", {
                  attrs: {
                    path: "DELETE_AFFILIATE_MODAL_ASSOCIATION_TEXT",
                    tag: "span"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "publisherName",
                        fn: function() {
                          return [
                            _c("strong", [_vm._v(_vm._s(_vm.publisher.name))])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2101422650
                  )
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
              _c("div", { staticClass: "form-horizontal" }, [
                _vm.publisherReferences.campaigns &&
                _vm.publisherReferences.campaigns.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Campaigns")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(_vm.publisherReferences.campaigns, function(
                            campaign,
                            index
                          ) {
                            return _c("li", { key: index }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.right.hover",
                                      value: _vm.$t("VIEW_CAMPAIGN"),
                                      expression: "$t('VIEW_CAMPAIGN')",
                                      modifiers: { right: true, hover: true }
                                    }
                                  ],
                                  attrs: {
                                    href: `#/dashboard/campaign/${campaign.campaignId}`,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "display-text",
                                      attrs: { title: campaign.campaignName }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(campaign.campaignName) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-external-link m-l-5"
                                  })
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.publisherReferences.numbers &&
                _vm.publisherReferences.numbers.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Numbers")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(_vm.publisherReferences.numbers, function(
                            number
                          ) {
                            return _c("li", { key: number.id }, [
                              _c(
                                "span",
                                {
                                  staticClass: "display-text",
                                  attrs: { title: number.numberName }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(number.numberName) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.publisherReferences.numberpools &&
                _vm.publisherReferences.numberpools.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Number Pools")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(_vm.publisherReferences.numberpools, function(
                            numberPool,
                            index
                          ) {
                            return _c("li", { key: index }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.right.hover",
                                      value: _vm.$t(
                                        "DELETE_AFFILIATE_MODAL_VIEW_NUMBER_POOL"
                                      ),
                                      expression:
                                        "\n                    $t('DELETE_AFFILIATE_MODAL_VIEW_NUMBER_POOL')\n                  ",
                                      modifiers: { right: true, hover: true }
                                    }
                                  ],
                                  attrs: {
                                    href: `#/dashboard/campaign/${numberPool.numberpoolId}`,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "display-text",
                                      attrs: {
                                        title: numberPool.numberpoolName
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(numberPool.numberpoolName) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-external-link m-l-5"
                                  })
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.publisherReferences.ringbausers &&
                _vm.publisherReferences.ringbausers.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Users")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(_vm.publisherReferences.ringbausers, function(
                            user,
                            index
                          ) {
                            return _c("li", { key: index }, [
                              _c(
                                "span",
                                {
                                  staticClass: "display-text",
                                  attrs: { title: user.ringbauserName }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(user.ringbauserName) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm.publisherReferences &&
            _vm.publisherReferences.numbers &&
            _vm.publisherReferences.numbers.length > 0
              ? _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
                  _c("div", { staticClass: "row form-horizontal" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("NzToggle", {
                          attrs: { name: "keepNumbers" },
                          model: {
                            value: _vm.keepNumbers,
                            callback: function($$v) {
                              _vm.keepNumbers = $$v
                            },
                            expression: "keepNumbers"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "col-md-6 form-control-static" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("DELETE_AFFILIATE_KEEP_NUMBERS_TEXT")) +
                          "\n        "
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }